// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"styles__arrowIcon___XvNkJ","addIcon":"styles__addIcon___ovlz4"};